import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

/* ===== Pipeline dropdown (used by PipelineDistribution) ===== */
export function PipelineDropdown({ pipelines = [], value, onChange }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target))
        setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div className="sd-range-dd-pos" ref={wrapRef}>
      <button
        type="button"
        className="sd-range-dd-btn"
        onClick={() => setOpen((v) => !v)}
      >
        <span>
          {value?.pipeline_name?.length > 10
            ? `${value.pipeline_name.slice(0, 10).trim()}...`
            : value?.pipeline_name || "Select Pipeline"}
        </span>
        <FiChevronDown
          size={12}
          className={`sd-caret ${open ? "sd-caret-open" : ""}`}
        />
      </button>
      {open && (
        <div
          className="sd-dropdown sd-range-dd-menu"
          style={{ maxHeight: 260, overflowY: "auto" }}
        >
          {pipelines.length === 0 && (
            <div
              className="sd-dropdown-item sd-table-muted"
              style={{ cursor: "default" }}
            >
              No pipelines found
            </div>
          )}
          {pipelines.map((p) => (
            <div
              key={p.id}
              className={`sd-dropdown-item ${value?.id === p.id ? "sd-dropdown-item-active" : ""}`}
              onClick={() => {
                onChange(p);
                setOpen(false);
              }}
            >
              {p.pipeline_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
